type ProjectWorkspaceCacheInvalidation = {
  uploadId?: string;
};

type ProjectWorkspaceCacheListener = (invalidation: ProjectWorkspaceCacheInvalidation) => void;

const listeners = new Set<ProjectWorkspaceCacheListener>();

export const invalidateProjectWorkspaceCache = (uploadId?: string) => {
  listeners.forEach(listener => listener({ uploadId }));
};

export const subscribeToProjectWorkspaceCacheInvalidation = (
  listener: ProjectWorkspaceCacheListener
) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
